import React from "react";

import { useTranslation } from "utils";

import { RequirementLevel } from "models";

import { Flex, Form, KlimRadioGroup, Typography } from "components";

import { isRequired, isRequiredForSaving } from "pages/app/all-field-view/utils/getInputRequirementConfig";

type Option = {
  label: string;
  value: boolean;
};

const options: Option[] = [
  {
    label: "fertilizerForm.yes",
    value: true,
  },
  {
    label: "fertilizerForm.no",
    value: false,
  },
];

type FertilizerManagementYesNoFormProps = {
  initialValue: boolean | null;
  disabled?: boolean;
  requirementLevel?: RequirementLevel;
  mixedValues?: boolean;
};

export const FertilizerManagementYesNoForm = ({ initialValue, disabled, requirementLevel, mixedValues }: FertilizerManagementYesNoFormProps) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex vertical className="tillage-yes-no-form reduced-view">
      <Flex>
        <Typography variant="h5">{t("fertilizerForm.fertilizerManagement.title")}</Typography>
      </Flex>
      <div className="form-container" data-testid="add-edit-fertilizer-management-yes-no-form">
        <Flex justify="space-between" gap="1rem" className="margin-top-100">
          <Typography variant="paragraph-m">
            {t("fertilizerForm.fertilizerManagement.question")} {isRequired(requirementLevel) && "*"}
          </Typography>
          <Form.Item
            name="hasFertilizerManagement"
            initialValue={initialValue}
            rules={[{ required: isRequiredForSaving(requirementLevel), message: t("fertilizerForm.fertilizerManagement.required") }]}
            help={mixedValues ? t("cropForm.mixedValues") : undefined}
          >
            <KlimRadioGroup
              className="radio-bg-white"
              size="large"
              type="tertiary"
              dataTestId="fertilizer-management-toggle"
              options={options.map((option) => ({
                label: (
                  <Flex vertical justify="space-around">
                    <Typography variant="paragraph-m">{t(option.label)}</Typography>
                  </Flex>
                ),
                value: option.value,
              }))}
              optionType="button"
              buttonStyle="solid"
              disabled={disabled}
            />
          </Form.Item>
        </Flex>
      </div>
    </Flex>
  );
};
